module.exports = __webpack_public_path__ + "img/full-link.3a8d7b27.png";